import { IPersistedMyClaimsFilters } from '../../types';

export const persistMyClaimsFiltersAction = (filters: IPersistedMyClaimsFilters) => {
  return {
    type: 'MY_CLAIMS_LIST_FILTERS_PERSIST',
    payload: {
      ...filters,
    },
  };
};
